'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reactRedux = require('react-redux');

var _taxonomies = require('redux/modules/taxonomies');

var _terms = require('redux/modules/terms');

var termActions = _interopRequireWildcard(_terms);

var _reduxRouter = require('redux-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _utils = require('utils');

var _decorate = require('helpers/decorate');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Term = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destroyed: state.terms.destroyed,
    entity: 'terms',
    error: state.terms.error,
    queryParams: state.terms.queryParams,
    terms: state.terms.terms,
    taxonomies: state.taxonomies.taxonomies.data,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, termActions, { push: _reduxRouter.push, replace: _reduxRouter.replace })), _dec2 = (0, _decorate.container)(['openModal', 'closeModal']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Term, _Component);

  function Term(props, context, updater) {
    (0, _classCallCheck3.default)(this, Term);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Term.__proto__ || (0, _getPrototypeOf2.default)(Term)).call(this, props, context, updater));

    _this.state = {
      isModalOpen: false,
      selectedEditItem: {}
    };

    _this.state.snackbar = (0, _utils.snackbarInitialState)();
    return _this;
  }

  (0, _createClass3.default)(Term, [{
    key: 'onPagerSelect',
    value: function onPagerSelect(eventKey) {
      var queryParams = this.props.queryParams;
      var _props = this.props,
          slug = _props.params.slug,
          push = _props.push,
          taxonomies = _props.taxonomies; // eslint-disable-line no-shadow

      var taxonomy = taxonomies.find(function (tax) {
        return tax.slug === slug;
      });

      queryParams = (0, _extends3.default)({}, queryParams, eventKey);

      push({ pathname: '/taxonomies/' + taxonomy.slug, query: queryParams });
    }
  }, {
    key: 'onFilterTerms',
    value: function onFilterTerms(term) {
      var _this2 = this;

      var newFilter = {
        q: term.target.value.trim(),
        page: 1
      };

      if (this.filterTextListener) {
        clearTimeout(this.filterTextListener);
      }

      this.filterTextListener = setTimeout(function () {
        _this2.onPagerSelect(newFilter);
      }, 800);
    }
  }, {
    key: 'openModal',
    value: function openModal(selectedItem) {
      if (this.canOpenModal(selectedItem)) {
        var _props2 = this.props,
            slug = _props2.params.slug,
            _push = _props2.push,
            queryParams = _props2.queryParams,
            taxonomies = _props2.taxonomies; // eslint-disable-line no-shadow

        var taxonomy = taxonomies.find(function (tax) {
          return tax.slug === slug;
        });

        _push({
          pathname: '/taxonomies/' + taxonomy.slug + '/' + this.props.entity + '/' + (selectedItem.id || 'new'),
          query: queryParams
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var _props3 = this.props,
          slug = _props3.params.slug,
          push = _props3.push,
          queryParams = _props3.queryParams,
          taxonomies = _props3.taxonomies; // eslint-disable-line no-shadow

      var taxonomy = taxonomies.find(function (tax) {
        return tax.slug === slug;
      });

      push({
        pathname: '/taxonomies/' + taxonomy.slug,
        query: queryParams
      });
    }
  }, {
    key: 'canOpenModal',
    value: function canOpenModal() {
      return ['super_admin', 'admin'].indexOf(this.props.user.role) > -1;
    }
  }, {
    key: 'reloadTerms',
    value: function reloadTerms() {
      var _props4 = this.props,
          queryParams = _props4.queryParams,
          load = _props4.load;

      load(queryParams);
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy(termId, evt) {
      var _this3 = this;

      evt.preventDefault();
      var _props5 = this.props,
          destroy = _props5.destroy,
          locale = _props5.user.lang; // 194

      var termsPhrases = require('./../../locales/' + locale + '/terms.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, termsPhrases, appPhrases)
      });
      destroy(termId).then(function (res) {
        if (res.type === 'caligram/terms/DESTROY_SUCCESS') {
          var snackbar = _this3.state.snackbar;


          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              id: termId,
              isActive: true,
              message: polyglot.t('snackbar.termDestroyed', { title: res.result.name ? (0, _utils.trunc)(res.result.name, 20, true) : '' }),
              action: polyglot.t('snackbar.undo'),
              currentAction: res.type
            }
          });

          _this3.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'hideSnackbar',
    value: function hideSnackbar() {
      var snackbar = this.state.snackbar;


      snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
        $merge: {
          id: 0,
          isActive: false
        }
      });

      this.setState({ snackbar: snackbar });
    }
  }, {
    key: 'handleDismissSnackbar',
    value: function handleDismissSnackbar() {
      this.hideSnackbar();
    }
  }, {
    key: 'handleClickSnackbar',
    value: function handleClickSnackbar() {
      var _this4 = this;

      var snackbar = this.state.snackbar;


      switch (snackbar.currentAction) {
        case 'caligram/terms/DESTROY_SUCCESS':
          var _props6 = this.props,
              restore = _props6.restore,
              destroyed = _props6.destroyed;

          restore(destroyed.id).then(function (res) {
            if (res.type === 'caligram/terms/RESTORE_SUCCESS') {
              _this4.hideSnackbar();
            }
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this,
          _context2;

      var _props7 = this.props,
          taxonomies = _props7.taxonomies,
          terms = _props7.terms,
          slug = _props7.params.slug,
          queryParams = _props7.queryParams,
          locale = _props7.user.lang;

      var termsPhrases = require('./../../locales/' + locale + '/terms.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, termsPhrases, appPhrases)
      });
      var snackbar = this.state.snackbar;


      var taxonomy = taxonomies.find(function (tax) {
        return tax.slug === slug;
      });

      var meta = {
        pagination: {
          current_page: 0,
          total: 0,
          total_pages: 0
        }
      };

      if (terms && terms.meta) {
        meta = terms.meta;
      }

      var termData = [];
      if (terms && terms.data) {
        termData = terms.data;
      }

      var showPager = (0, _classnames2.default)({
        hide: meta.pagination.total_pages <= 1
      });

      var pagerPrevDisabled = meta.pagination.current_page <= 1;
      var pagerNextDisabled = meta.pagination.current_page >= meta.pagination.total_pages;

      var pager = _react2.default.createElement(
        _reactBootstrap.Pager,
        { onSelect: this.onPagerSelect.bind(this), className: showPager },
        _react2.default.createElement(
          _reactBootstrap.Pager.Item,
          { className: 'icon-cg-chevron-left', disabled: pagerPrevDisabled, eventKey: { page: meta.pagination.current_page - 1 }, href: '#?previous' },
          polyglot.t('terms.previous')
        ),
        '\xA0',
        _react2.default.createElement(
          _reactBootstrap.Pager.Item,
          { className: 'icon-cg-chevron-right', disabled: pagerNextDisabled, eventKey: { page: meta.pagination.current_page + 1 }, href: '#?next' },
          polyglot.t('terms.next')
        )
      );

      var filters = _react2.default.createElement(
        'div',
        { className: 'filters clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'form-inline' },
          _react2.default.createElement(
            'div',
            { className: 'form-group pull-right' },
            _react2.default.createElement('input', { type: 'search', className: 'form-control', placeholder: '\xA0', defaultValue: queryParams.q, onChange: this.onFilterTerms.bind(this) })
          )
        )
      );

      var termsList = termData.length ? termData.map(function (term) {
        var _context;

        return _react2.default.createElement(_components.TermItem, {
          key: String(term.id),
          term: term,
          openModal: (_context = _this5.openModal).bind.call(_context, _this5, term),
          destroy: _this5.handleDestroy.bind(_this5)
        });
      }) : polyglot.t('terms.empty');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: taxonomy.name + ' - Caligram' }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-lg btn-primary pull-right',
              onClick: (_context2 = this.openModal).bind.call(_context2, this, {})
            },
            polyglot.t('terms.new')
          ),
          _react2.default.createElement(
            'h1',
            null,
            taxonomy.name
          )
        ),
        filters,
        _react2.default.createElement(
          'div',
          { className: 'results' },
          termsList,
          pager
        ),
        _react2.default.createElement(_components.TermModal, {
          isModalOpen: this.state.isModalOpen,
          closeModal: this.closeModal.bind(this),
          taxonomyId: taxonomy.id,
          termId: this.state.selectedEditItem.id,
          polyglot: polyglot }),
        _react2.default.createElement(_components.Snackbar, (0, _extends3.default)({
          ref: 'snackbar'
        }, snackbar, {
          style: (0, _utils.snackbarStyle)(),
          onDismiss: this.handleDismissSnackbar.bind(this),
          onClick: this.handleClickSnackbar.bind(this),
          polyglot: polyglot }))
      );
    }
  }], [{
    key: 'fetchData',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(getState, dispatch, location) {
        var state, nextState, queryParams, parsedParams, slug, taxonomy, mergedParams, paramsChanged;
        return _regenerator2.default.wrap(function _callee$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();

                if (state.taxonomies.loaded || state.taxonomies.loading) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return dispatch((0, _taxonomies.load)());

              case 4:
                _context3.next = 9;
                break;

              case 6:
                if (!state.taxonomies.promise) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return state.taxonomies.promise;

              case 9:
                nextState = getState();
                queryParams = nextState.terms.queryParams;
                parsedParams = _queryString2.default.parse(location.search);

                // 3 because it starts with a /

                slug = location.pathname.split('/', 3).pop().split('/', 2).shift();
                taxonomy = nextState.taxonomies.taxonomies.data.find(function (tax) {
                  return tax.slug === slug;
                });
                mergedParams = (0, _extends3.default)({}, queryParams, parsedParams, {
                  taxonomy_id: taxonomy.id
                });
                paramsChanged = _queryString2.default.stringify(queryParams) !== _queryString2.default.stringify(mergedParams);

                if (!(paramsChanged || !(nextState.terms.loaded || nextState.terms.loading))) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 19;
                return dispatch((0, _terms.changeFilter)(mergedParams));

              case 19:
                _context3.next = 21;
                return dispatch((0, _terms.load)(mergedParams));

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  }]);
  return Term;
}(_react.Component), _class2.propTypes = {
  changeFilter: _propTypes2.default.func.isRequired,
  destroy: _propTypes2.default.func.isRequired,
  destroyed: _propTypes2.default.object,
  entity: _propTypes2.default.string.isRequired,
  load: _propTypes2.default.func,
  params: _propTypes2.default.object.isRequired,
  push: _propTypes2.default.func.isRequired,
  queryParams: _propTypes2.default.object,
  restore: _propTypes2.default.func.isRequired,
  taxonomies: _propTypes2.default.any,
  terms: _propTypes2.default.any,
  user: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = Term;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Term/Term.js
// module id = 2272
// module chunks = 0